import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiAlertCircle, FiCheckCircle, FiInfo } from 'react-icons/fi';

const Callout = ({ type = 'info', title, children }) => {
  const configs = {
    info: { bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-900', icon: FiInfo, iconColor: 'text-blue-500' },
    warning: { bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-900', icon: FiAlertCircle, iconColor: 'text-amber-500' },
    success: { bg: 'bg-green-50', border: 'border-green-200', text: 'text-green-900', icon: FiCheckCircle, iconColor: 'text-green-500' },
  };

  const config = configs[type];

  return (
    <div className={`my-6 p-4 rounded-lg border ${config.bg} ${config.border}`}>
      <div className="flex gap-3">
        <SafeIcon icon={config.icon} className={`mt-0.5 w-5 h-5 flex-shrink-0 ${config.iconColor}`} />
        <div>
          {title && <h4 className={`font-semibold mb-1 ${config.text}`}>{title}</h4>}
          <div className={`text-sm leading-relaxed text-opacity-90 ${config.text}`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Callout;